<template>
  <div class="prize-table">
    <CampaignPrizeDialog :prizeCount="options.total" ref="campaignPrizeDialog" />
    <el-table
      v-if="campaign.type"
      class="mb-x2"
      :data="prizes"
      stripe
      @header-click="headerClick"
      empty-text=" "
      style="width: 100%"
    >
      <el-table-column
        label="応募グループ名"
        sort-by="name"
        :render-header="renderHeader"
        :min-width="campaign.type === 'old_web_instantwin' ? '17%' : '25%'"
      >
        <template slot-scope="scope">
          <div class="link" @click="openCampaignApplicant(scope.row.id)">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="応募キーワード"
        sort-by="entryKeyword"
        :render-header="renderHeader"
        :min-width="campaign.type === 'old_web_instantwin' ? '17%' : '37%'"
      >
        <template slot-scope="scope"
          ><span class="text-disabled mr-x1">全て含む</span
          ><span v-if="campaign.type !== 'old_web_instantwin'"
            ><span v-if="campaign.setting">{{ JSON.parse(campaign.setting.searchKeyword).join(' ') }}</span
            ><span>{{ scope.row.entryKeyword && scope.row.entryKeyword.join(' ') }} {{ ' ' }}</span></span
          ><span v-else>
            <div v-if="campaign.setting">
              <div v-for="(keyword, index) in JSON.parse(campaign.setting.searchKeyword)" :key="index">
                {{ keyword }}
              </div>
            </div>
            <div v-if="scope.row.entryKeyword">
              <div v-for="(keyword, index) in scope.row.entryKeyword" :key="index">
                {{ keyword }}
              </div>
            </div>
          </span>
          <div
            v-if="
              campaign.setting &&
              campaign.setting.orKeyword &&
              JSON.parse(campaign.setting.orKeyword) &&
              JSON.parse(campaign.setting.orKeyword).length
            "
          >
            <span class="text-disabled mr-x1">いずれか含む</span
            ><span v-if="campaign.type !== 'old_web_instantwin'">{{
              JSON.parse(campaign.setting.orKeyword).join(' ')
            }}</span
            ><span v-else>
              <div>
                <div v-for="(keyword, index) in JSON.parse(campaign.setting.orKeyword)" :key="index">
                  {{ keyword }}
                </div>
              </div>
            </span>
          </div>
          <div v-if="isIncludeQuoteTweets">
            <span class="text-disabled mr-x1">引用:全てを含む</span
            ><span v-if="scope.row.commentKeyword && campaign.type !== 'old_web_instantwin'">{{
              scope.row.commentKeyword.join(' ')
            }}</span>
            <div v-if="scope.row.commentKeyword && campaign.type === 'old_web_instantwin'">
              <div v-for="(keyword, index) in scope.row.commentKeyword" :key="index">
                {{ keyword }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="campaign.type === 'old_web_instantwin'"
        label="期間"
        sort-by="-startDatetime"
        :render-header="renderHeader"
        min-width="17%"
      >
        <template slot-scope="scope">
          <div v-if="!scope.row.startDatetime && !scope.row.endDatetime">-</div>

          <div v-else>
            <div>
              <span v-if="scope.row.startDatetime">
                {{ formatDatetime(scope.row.startDatetime) }}
                <template v-if="scope.row.endDatetime"> -</template>
              </span>
              <span v-else>~</span>
            </div>
            <div>
              <span v-if="scope.row.endDatetime">{{ formatDatetime(scope.row.endDatetime) }}</span>
              <span v-else>~</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-show="campaign.type === 'old_web_instantwin'"
        label="応募者数"
        sort-by="-applicantCount"
        :render-header="renderHeader"
        min-width="10%"
      >
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.applicantCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="当選者数" sort-by="-winnerCount" :render-header="renderHeader" min-width="10%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.winnerCount) }}</div>
          <div class="sub-value">残り:&nbsp;{{ formatNumber(scope.row.maxWinnerCount - scope.row.winnerCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="campaign.type === 'old_web_instantwin'"
        label="当選数(本日)"
        :render-header="renderHeader"
        min-width="11%"
      >
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.webIwDailyWinnerCount) }}</div>
          <div class="sub-value" v-if="scope.row.maxWebIwDailyWinnerCount > 0">
            残り:&nbsp;{{ formatNumber(scope.row.maxWebIwDailyWinnerCount - scope.row.webIwDailyWinnerCount) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="推定リーチ" sort-by="-estimatedReachCount" :render-header="renderHeader" min-width="10%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.estimatedReachCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column min-width="8%">
        <template slot-scope="scope">
          <div layout layout-align="end">
            <el-tooltip :enterable="false" placement="top" content="編集">
              <el-button class="el-button--icon" type="default" @click="openCampaignDialogEdit(scope.row.id)">
                <i class="mdi mdi-table-edit" />
              </el-button>
            </el-tooltip>
            <a
              class="ml-x1"
              v-if="!!scope.row.previewUrl"
              :href="scope.row.previewUrl"
              target="_blank"
              @click="clickSnsConfirmEvent()"
            >
              <el-tooltip :enterable="false" placement="top" content="抽選中ページプレビュー">
                <el-button class="el-button--icon" type="default"
                  ><img src="@/client/assets/images/twitter-web-instant-circle.svg"
                /></el-button> </el-tooltip
            ></a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        :type="campaign.snsType"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.text-disabled {
  font-size: $font-small-size;
}

.sub-value {
  font-size: $font-small-size;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import CampaignPrizeDialog from '@/client/features/twitter_campaign_prize/campaign_prize_dialog'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useTwitterCampaignPrizeStore } from '@/client/store/useTwitterCampaignPrizeStore'

export default defineComponent({
  props: {
    prizes: Array,
    options: Object,
    onChangePagingNo: Function,
    onChangeLimitCount: Function,
    onChangeSortBy: Function
  },
  components: {
    Pagination,
    Icon,
    CampaignPrizeDialog
  },
  computed: {
    ...mapState(useTwitterCampaignPrizeStore, {
      campaign: state => state.campaign ?? {}
    }),
    isIncludeQuoteTweets() {
      if (!this.campaign?.setting?.entryActionType) {
        return false
      }

      return ['retweet_and_quote_tweet', 'quote_tweet'].includes(this.campaign.setting.entryActionType)
    }
  },
  methods: {
    formatDatetime,
    formatNumber,

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case '応募グループ名':
          TrackingService.sendEvent('sort:応募グループ一覧（X）|応募グループ名')
          break
        case '応募キーワード':
          TrackingService.sendEvent('sort:応募グループ一覧（X）|応募キーワード')
          break
        case '期間':
          TrackingService.sendEvent('sort:応募グループ一覧（X）|期間')
          break
        case '応募者数':
          TrackingService.sendEvent('sort:応募グループ一覧（X）|応募者数')
          break
        case '当選者数':
          TrackingService.sendEvent('sort:応募グループ一覧（X）|当選者数')
          break
        case '当選数(本日)':
          TrackingService.sendEvent('sort:応募グループ一覧（X）|当選数(本日)')
          break
        case '推定リーチ':
          TrackingService.sendEvent('sort:応募グループ一覧（X）|推定リーチ')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(
        createElement,
        column.label,
        Util.getSortClass(this.options.sortBy, column.sortBy),
        Boolean(column.sortBy)
      )
    },

    openCampaignApplicant(id: number) {
      TrackingService.sendEvent('click:応募グループ一覧（X）|グループ名')

      this.$router.push('/twitter_campaigns/' + this.campaign.id + '/prizes/' + id + '/applicants')
    },

    clickSnsConfirmEvent() {
      TrackingService.sendEvent('click:応募グループ一覧（X）|WEBプレビュー')
    },

    openCampaignDialogEdit(id: number) {
      TrackingService.sendEvent('click:応募グループ一覧（X）|編集')

      this.$refs.campaignPrizeDialog.open(this.campaign.id, id)
    }
  }
})
</script>
